// extracted by mini-css-extract-plugin
export var colorSquare = "_q2-0";
export var danger = "_q2-5";
export var lightPink = "_q2-8";
export var neutralBlue = "_q2-7";
export var neutralYellow = "_q2-6";
export var normal = "_q2-1";
export var primary = "_q2-2";
export var primaryLight = "_q2-3";
export var solidBlack = "_q2-g";
export var solidGreen = "_q2-b";
export var solidLightBlue = "_q2-d";
export var solidNavy = "_q2-c";
export var solidOrange = "_q2-f";
export var solidPink = "_q2-e";
export var solidRed = "_q2-9";
export var solidYellow = "_q2-a";
export var success = "_q2-4";